import React from 'react';
import { Link } from 'react-router-dom';
import { isAdmin } from '../utils/admin';
import './Navbar.css';

const Navbar = ({ user, onLogout }) => {
  return (
    <nav className="navbar">
      <div className="container">
        <div className="navbar-content">
          <Link to="/" className="navbar-brand">
            <img src="/logo.png" alt="Yuan" className="navbar-logo" />
          </Link>
          <div className="navbar-links">
            <Link to="/" className="navbar-link">Classes</Link>
            <Link to="/posts" className="navbar-link">Posts</Link>
            <Link to="/policy" className="navbar-link">Policy</Link>
            {user && isAdmin(user) && (
              <Link to="/admin" className="navbar-link">Admin</Link>
            )}
            {user ? (
              <>
                <span className="navbar-user">Welcome, {user.name || user.email || 'User'}!</span>
                <Link to="/profile" className="navbar-link">Profile</Link>
                <button onClick={onLogout} className="btn btn-secondary btn-sm">Logout</button>
              </>
            ) : (
              <>
                <Link to="/login" className="btn btn-primary btn-sm">Login</Link>
                <Link to="/register" className="btn btn-secondary btn-sm">Register</Link>
              </>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;


